// remove after adding the strategy for searcher names
export enum Tab { //eslint-disable-line @stencil-community/ban-exported-const-enums
	ALL = 'se/all',
	PRODUCTS = 'se/products',
	DOCUMENTS = 'se/documents',
	SOFTWARE = 'se/software',
	FAQ = 'se/faq',
	COMPANY = 'se/company',
	SOLUTIONS = 'se/solutions',
	SERVICES = 'se/services',
	SUPPORT = 'se/support'
}
